import { createMasterScreen } from '../../../components/erp/ERPMasterScreenFactory';
export default createMasterScreen({
  title: 'Sub UOM Master', screenId: '4.1.12', module: 'Procurement', apiPath: 'subuom', screenName: 'SubUOMMaster', idField: 'SubUOmId', nameField: 'SubUomName',
  gridColumns: [{ field: 'SubUOmId', header: 'Sub UOM ID' }, { field: 'SubUomName', header: 'Sub UOM Name' }, { field: 'UOMID', header: 'Parent UOM' }],
  formFields: [{ field: 'SubUOmId', label: 'Sub UOM Id', disabled: true }, { field: 'SubUomName', label: 'Sub UOM Name', required: true }, { field: 'UOMID', label: 'Parent UOM ID' }]
});
